import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

import { ServerValidationError } from '@/api/shared/types'

import { RequestsService } from '../lib/requests.service'
import type {
  CreateRequestApi,
  CreateServiceRequestDTO
} from '../lib/requests.types'
import { REQUESTS_LIST_RQ_KEY } from './useRequestsList'

export const useCreateServiceRequest = () => {
  const queryClient = useQueryClient()

  return useMutation<
    AxiosResponse<CreateRequestApi>,
    AxiosError<ServerValidationError>,
    CreateServiceRequestDTO
  >({
    mutationFn: (data: CreateServiceRequestDTO) =>
      RequestsService.createServiceRequest(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [REQUESTS_LIST_RQ_KEY]
      })
    }
  })
}
